import { useState, useEffect } from 'react';
import { Mail } from 'lucide-react';

// Protected Email Link Component
// Renders email only after component mounts (client-side)
// Bots that don't execute JS won't see the real email

export const ProtectedEmail = ({ 
  className = '', 
  showIcon = false,
  subject = '',
  children 
}) => {
  const [email, setEmail] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  // Only reveal email client-side after mount
  useEffect(() => {
    // Decode the email on client side
    const user = 'info';
    const domain = 'hafner-ec.com';
    setEmail(`${user}@${domain}`);
  }, []);

  if (!email) {
    // Server-side / initial render - show placeholder
    return (
      <span className={`text-[#0284C7] ${className}`}>
        {children || 'E-Mail senden'}
      </span>
    );
  }

  const mailtoLink = subject 
    ? `mailto:${email}?subject=${encodeURIComponent(subject)}`
    : `mailto:${email}`;

  return (
    <a
      href={mailtoLink}
      className={`text-[#0284C7] hover:underline inline-flex items-center gap-1 transition-colors ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={(e) => {
        // Additional protection: construct mailto on click
        e.preventDefault();
        window.location.href = mailtoLink;
      }}
      data-testid="protected-email"
    >
      {showIcon && <Mail size={16} className="flex-shrink-0" />}
      {children || email}
    </a>
  );
};

// Protected Phone Link Component
export const ProtectedPhone = ({ 
  className = '',
  children 
}) => {
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    setPhone({
      display: '+39 0473 238 030',
      tel: '+390473238030'
    });
  }, []);

  if (!phone) {
    return (
      <span className={className}>
        {children || 'Telefon'}
      </span>
    );
  }

  return (
    <a
      href={`tel:${phone.tel}`}
      className={`text-[#0284C7] hover:underline ${className}`}
      data-testid="protected-phone"
    >
      {children || phone.display}
    </a>
  );
};

// Honeypot field for forms (if you add forms later)
export const HoneypotField = () => {
  return (
    <div 
      style={{ 
        position: 'absolute', 
        left: '-9999px',
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      }}
      aria-hidden="true"
    >
      <label htmlFor="website">Website</label>
      <input 
        type="text" 
        name="website" 
        id="website"
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
};

export default ProtectedEmail;
